// サイドナビの現在ページにカレント表示を付与
// WordPress 移行後は PHP 側で同等のクラスを付与する想定
export const initSideNavCurrent = () => {
  const currentPath = window.location.pathname.replace(/\/$/, '');
  // ロゴのリンク（TOPと同URL・DOM上で先に来る）を拾わないよう、ナビリスト内に限定する
  const links = document.querySelectorAll('.side-nav .list a[href]');

  // 現在ページに一致するリンクを選ぶ。
  // 完全一致だけでなく、現在ページがリンク先の子孫（詳細ページ等）の場合も一致とみなし、
  // 一致するリンクのうち最も具体的（パスが最長）なものをカレントにする。
  // これにより一覧に載らない詳細ページでも、親メニュー項目が開いたままになる。
  let currentLink = null;
  let currentLinkLength = -1;
  links.forEach(link => {
    const linkPath = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '');
    const isMatch = linkPath === currentPath || currentPath.startsWith(`${linkPath}/`);
    if (isMatch && linkPath.length > currentLinkLength) {
      currentLink = link;
      currentLinkLength = linkPath.length;
    }
  });

  if (!currentLink) return;

  const subitem = currentLink.closest('.subitem');
  if (subitem) {
    // サブメニュー: <li class="subitem"> にカレント、親メニューにも -current
    subitem.classList.add('-current');
    const parentItem = currentLink.closest('.item.-parent');
    const toggle = parentItem?.querySelector('.js-side-nav-toggle');
    if (toggle) {
      toggle.classList.add('-current');
      // カレント親はサブメニューを開いておく（初期表示なのでアニメーション無しで開く）
      toggle.classList.add('-active');
      const sub = toggle.nextElementSibling;
      if (sub) {
        sub.style.transition = 'none';
        sub.style.height = 'auto';
        // 1フレーム後に transition を戻す（クリック時はアニメーションが効くように）
        requestAnimationFrame(() => {
          sub.style.transition = '';
        });
      }
    }
  } else {
    // 親メニュー: <a class="link label"> にカレント
    currentLink.classList.add('-current');
  }
};
